import {NzInputNumberComponent} from 'ng-zorro-antd/input-number';
import {NzSwitchComponent} from 'ng-zorro-antd/switch';
import {NzDatePickerComponent} from 'ng-zorro-antd/date-picker';
import {NzSliderComponent} from 'ng-zorro-antd/slider';
import {Type} from '@angular/core';

export const formItemTypes: { [key: string]: any } = {
  'input-number': NzInputNumberComponent,
  date: NzDatePickerComponent,
  // 'date-range': NzRangePickerComponent,
  // rate: NzRateComponent,
  slider: NzSliderComponent,
  switch: NzSwitchComponent,
};

export function GnFormItem(key: string) {
  return (target: Type<any>) => {
    formItemTypes[key] = target;
  };
}
